import { useFeatureIsOn, GrowthBookFeatureId as WsGrowthBookFeatureId } from '@helloworld1812/ws-growthbook';

export type GrowthbookFeatureId =
  | WsGrowthBookFeatureId
  | 'assign_interview'
  | 'async_task_widget_always_show'
  | 'boj_employement_status'
  | 'company_customize_ai_assistant_info'
  | 'company_documents'
  | 'custom_field'
  | 'custom_report_export'
  | 'data_export_tool'
  | 'hris-jobs'
  | 'ehx-wotc-integration'
  | 'employee_record_custom_field'
  | 'employee_records'
  | 'enable_paychex_emergency_contact_support'
  | 'eo_payroll_integration'
  | 'er_paywall'
  | 'formi9_dot_com'
  | 'hr-auth-portal-login'
  | 'interview-scheduling-2.1'
  | 'meeting-details-merge-tag'
  | 'new_direct_deposit'
  | 'new-user-activation'
  | 'nfw_group_c'
  | 'paychex_onboard_module'
  | 'payroll-employees-integration'
  | 'payroll-integration'
  | 'position_custom_fields'
  | 'role-based-assignment-for-signing-stage'
  | 'show_adp_wfn_onboarding_flow_option'
  | 'social_optimizer'
  | 'sourcing_tools'
  | 'spanish_translation_phase_2'
  | 'super_admin_dashboard'
  | 'tax-entity-permissions'
  | 'team-management-permissions'
  | 'timeline_widget_hr'
  | 'ukg_integration_v2'
  | 'us_state_tax'
  | 'location-based-hpt-and-jpt'
  | 'uscis_everify_cases'
  | 'onboarding_analytics'
  | 'improved-candidate-rejection'
  | 'view_sensitive_pii'
  | 'hiring-dashboard'
  | 'form_i9_upload_file'
  | 'enable-indeed-sponsor-under-review'
  | 'hiring-dashboard';

export function useIsFeatureOn(featureId: GrowthbookFeatureId) {
  return useFeatureIsOn(featureId as WsGrowthBookFeatureId);
}
